/*
 * Moves the Pumper Bundles free-gift section ("+ X Gratis Geschenke")
 * between the Pumper bundle widget and the add-to-cart form. Pumper
 * injects that section on its own (no placement setting), so we
 * reposition it after it renders. Safe no-op when no gift section is
 * on the page.
 *
 * The found gift root is tagged with data-bb-gift so later observer
 * passes recognize it instead of re-deriving a root — re-deriving after
 * the move would climb to an ancestor that contains the add-to-cart
 * form and relocate the whole form component.
 */
(() => {
  if (window.__bbGiftReposition) return;
  window.__bbGiftReposition = true;

  const HEADING_RE = /Gratis\s+Geschenke/i;

  // Climb from el to the outermost wrapper that still excludes the buy
  // buttons and the add-to-cart form, so we never grab a shared ancestor.
  const climb = (el, buyButtons, form) => {
    let root = el;
    while (
      root.parentElement &&
      root.parentElement !== document.body &&
      !root.parentElement.contains(buyButtons) &&
      !(form && root.parentElement.contains(form))
    ) {
      root = root.parentElement;
    }
    return root;
  };

  const findGiftContainer = (buyButtons, form) => {
    const marked = document.querySelector('[data-bb-gift]');
    if (marked) return marked;
    // Prefer an explicit Pumper gift container when the app provides one
    for (const el of document.querySelectorAll('[class*="gift" i], [id*="gift" i]')) {
      const marker = (el.className + ' ' + el.id).toLowerCase();
      if (!marker.includes('pumper') && !el.closest('[id*="pumper" i], [class*="pumper" i]')) continue;
      if (el.contains(buyButtons) || (form && el.contains(form)) || !el.offsetParent) continue;
      return climb(el, buyButtons, form);
    }
    // Fallback: locate the section by its heading text
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      if (!HEADING_RE.test(walker.currentNode.textContent)) continue;
      const el = climb(walker.currentNode.parentElement, buyButtons, form);
      if (!el.contains(buyButtons) && !(form && el.contains(form))) return el;
    }
    return null;
  };

  // The "+ X Gratis Geschenke" panel on the product page is a theme
  // image-with-badges block rendered as a sibling of the buy-buttons
  // block. It belongs between the Pumper bundle widget and the
  // add-to-cart form, both of which live inside the buy-buttons block,
  // so template block order cannot express that placement.
  const repositionGiftImage = (buyButtons, form) => {
    const image = [...buyButtons.parentElement.children].find((el) =>
      el.classList.contains('image-with-badges')
    );
    if (!image || image.nextElementSibling === form) return;
    form.parentElement.insertBefore(image, form);
    // 20px collapses with the bundle widget's 16px bottom margin above,
    // giving an even 20px gap on both sides
    image.style.marginBlock = '20px';
  };

  const reposition = () => {
    const buyButtons = document.querySelector('.buy-buttons-block');
    if (!buyButtons || !buyButtons.parentElement) return;
    const form = buyButtons.querySelector('form.shopify-product-form');
    if (form) repositionGiftImage(buyButtons, form);
    const gift = findGiftContainer(buyButtons, form);
    if (!gift || gift.contains(buyButtons) || (form && gift.contains(form))) return;
    gift.setAttribute('data-bb-gift', '');
    // Preferred slot: directly before the add-to-cart form, i.e. below the
    // bundle widget that renders earlier inside the buy-buttons block
    if (form) {
      if (gift.nextElementSibling !== form || gift.parentElement !== form.parentElement) {
        form.parentElement.insertBefore(gift, form);
      }
      return;
    }
    // Fallback (no form found): keep the old placement above the buy buttons
    if (buyButtons.compareDocumentPosition(gift) & Node.DOCUMENT_POSITION_FOLLOWING) {
      buyButtons.parentElement.insertBefore(gift, buyButtons);
    }
  };

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      reposition();
    });
  };

  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  schedule();
})();
